import { Box, Divider } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzMuiRadioButton from "src/components/core-components/mui/buttons/ByzMuiRadioButton";
import ByzTitleAndInputBox from "src/components/core-components/ByzTitleAndInputBox/ByzTitleAndInputBox";

function PageTwo() {
  const { t } = useTranslate();
  
  const dischargeMethodOptions = [
    { value: "1", label: "Kucakta" },
    { value: "2", label: "Sedye" },
    { value: "3", label: "Transport Küvöz" },
    { value: "4", label: "Diğer" }
  ];

  const howWillGoOptions = [
    { value: "1", label: "Araba" },
    { value: "2", label: "Ambulans" },
    { value: "3", label: "Diğer" }
  ];

  const destinationOptions = [
    { value: "1", label: "Ev" },
    { value: "2", label: "Rehabilitasyon Merkezi" },
    { value: "3", label: "Diğer" }
  ];

  const childLivesWithOptions = [
    { value: "1", label: "Çocuk Esirgeme Kurumu" },
    { value: "2", label: "Yalnız" },
    { value: "3", label: "Eş" },
    { value: "4", label: "Anne" },
    { value: "5", label: "Baba" },
    { value: "6", label: "Arkadaş" },
    { value: "7", label: "Bakım evi" },
    { value: "8", label: "Akraba" },
    { value: "9", label: "Diğer(Belirtiniz)" }
  ];

  const checkupAppointmentOptions = [
    { value: "1", label: "Verildi" },
    { value: "2", label: "Verilmedi" }
  ];

  const hipUsgAppointmentOptions = [
    { value: "1", label: "Verildi" },
    { value: "2", label: "Verilmedi" }
  ];

  return (
    <>
      <Box p={2}>
        <Grid container spacing={2} >
          <Grid
            md={12}
            xs={12}
            container
            direction={"row"}
            spacing={2}
          >
            <Grid
              md={12}
              xs={12}
              container
              direction={"row"}
              spacing={2}
            >
              <Box
                sx={{
                  border: "1px solid #DBDBDB",
                  borderRadius: "4px",
                  padding: "20px",
                  width: "100%",
                }}
              >
                <Grid
                  sx={{
                    backgroundColor: "#63B4FF33",
                    color: "#2979C3",
                    borderRadius: "10px",
                  }}
                >
                  <ByzMuiTypography
                    isTitle
                    paddingRight={"20px"}
                    paddingTop={"5px"}
                  >
                    {t("newborn-patient-assessment.patient-requests-and-discharge-info")}
                  </ByzMuiTypography>
                </Grid>

                <Grid container spacing={2} pt={2}>
                  <Grid md={2} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px"
                      title={t("newborn-patient-assessment.discharge-method")}
                    >
                      <ByzMuiSelect
                        renderInput={(params) => (
                          <ByzMuiTextField {...params} />
                        )}
                        options={dischargeMethodOptions}
                        label= "label"
                        placeholder={t("open-process-menu.select")}
                        sx={{ pt: 1 }}
                        multiple = {false}
                      />

                      <ByzTitleAndInputBox marginLeft="0px" sx={{
                        marginTop: "8px", display: "flex", alignItems: "bottom",
                        justifyContent: "flex-end"
                      }}
                        title={t("description")}
                      >
                        <ByzMuiTextField
                          multiline={true}
                          rows={2}
                          sx={{
                            pt: 1,
                          }}
                        />
                      </ByzTitleAndInputBox>
                    </ByzTitleAndInputBox>
                  </Grid>

                  <Grid md={2} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px"
                      title={t("newborn-patient-assessment.how-will-go")}
                    >
                      <ByzMuiSelect
                        renderInput={(params) => (
                          <ByzMuiTextField {...params} />
                        )}
                        options={howWillGoOptions}
                        multiple = {false}
                        placeholder={t("open-process-menu.select")}
                        sx={{ pt: 1 }}
                        label= "label"
                      />

                      <ByzTitleAndInputBox marginLeft="0px" sx={{
                        marginTop: "8px", display: "flex", alignItems: "bottom",
                        justifyContent: "flex-end"
                      }}
                        title={t("description")}
                      >
                        <ByzMuiTextField
                          multiline={true}
                          rows={2}
                          sx={{
                            pt: 1,
                          }}
                        />
                      </ByzTitleAndInputBox>
                    </ByzTitleAndInputBox>
                  </Grid>

                  <Grid md={2} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px"
                      title={t("newborn-patient-assessment.destination")}
                    >
                      <ByzMuiSelect
                        renderInput={(params) => (
                          <ByzMuiTextField {...params} />
                        )}
                        options={destinationOptions}
                        label= "label"
                        placeholder={t("open-process-menu.select")}
                        sx={{ pt: 1 }}
                        multiple = {false}
                      />

                      <ByzTitleAndInputBox marginLeft="0px" sx={{
                        marginTop: "8px", display: "flex", alignItems: "bottom",
                        justifyContent: "flex-end"
                      }}
                        title={t("description")}
                      >
                        <ByzMuiTextField
                          multiline={true}
                          rows={2}
                          sx={{
                            pt: 1,
                          }}
                        />
                      </ByzTitleAndInputBox>
                    </ByzTitleAndInputBox>
                  </Grid>
                  <Grid md={3} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px" justifyContent="none"
                      title={t("newborn-patient-assessment.child-lives-with")}
                    >
                      <ByzMuiSelect
                        renderInput={(params) => (
                          <ByzMuiTextField {...params} />
                        )}
                        options={childLivesWithOptions}
                        label= "label"
                        placeholder={t("open-process-menu.select")}
                        multiple = {true}
                        sx={{ pt: 1 }}
                      />
                      <ByzTitleAndInputBox marginLeft="0px" sx={{
                        marginTop: "8px", display: "flex", alignItems: "bottom",
                        justifyContent: "flex-end"
                      }}
                        title={t("description")}
                      >
                        <ByzMuiTextField
                          multiline={true}
                          rows={2}
                          sx={{
                            pt: 1,
                          }}
                        />
                      </ByzTitleAndInputBox>
                    </ByzTitleAndInputBox>
                  </Grid>

                  <Grid md={3} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px" justifyContent="none"
                      title=""
                    >
                      <Grid container md={12} xs={6} alignItems={"center"}>
                        <Grid
                          md={2}
                          display="flex"
                          flexDirection="column"
                        >
                          <ByzMuiCheckBox />
                        </Grid>
                        <Grid md={10}>
                          <ByzMuiTypography marginLeft="0px">
                            {t("newborn-patient-assessment.home-care-needed")}
                          </ByzMuiTypography>
                        </Grid>
                      </Grid>

                      <ByzTitleAndInputBox marginLeft="0px" justifyContent="none" sx={{
                        display: "flex", alignItems: "bottom",
                        justifyContent: "flex-end"
                      }}
                        title={t("description")}
                      >
                        <ByzMuiTextField
                          multiline={true}
                          rows={2}
                          sx={{
                            pt: 1,
                          }}
                        />
                      </ByzTitleAndInputBox>
                    </ByzTitleAndInputBox>
                  </Grid>
                </Grid>

                <Divider
                  sx={{
                    borderColor: "black",
                    borderBottomWidth: "2px",
                    my: 2,
                  }}
                />

                <Grid container spacing={2}>
                  <Grid md={2} xs={6}>
                      <ByzTitleAndInputBox marginLeft="0px" justifyContent="none"
                        title=""
                      >
                        <Grid container md={12} xs={6} alignItems={"center"}>
                          <Grid
                            md={2}
                            display="flex"
                            flexDirection="column"
                          >
                            <ByzMuiCheckBox />
                          </Grid>
                          <Grid md={10}>
                            <ByzMuiTypography marginLeft="0px">
                              {t("newborn-patient-assessment.medical-equipment-needed")}
                            </ByzMuiTypography>
                          </Grid>
                        </Grid>

                        <ByzTitleAndInputBox marginLeft="0px" justifyContent="none" sx={{
                          marginTop: "8px", display: "flex", alignItems: "bottom",
                          justifyContent: "flex-end"
                        }}
                          title={t("description")}
                        >
                          <ByzMuiTextField
                            multiline={true}
                            rows={2}
                            sx={{
                              pt: 1,
                            }}
                          />
                        </ByzTitleAndInputBox>
                      </ByzTitleAndInputBox>
                    </Grid>
                    <Grid md={3} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px"
                      title={t("newborn-patient-assessment.mother-working")}
                    >
                      <ByzMuiRadioButton
                        typographyText="yes,no,unknown"
                        layout="row"
                        border="none"
                        fontSize={16}
                      />

                      <ByzTitleAndInputBox marginLeft="0px" sx={{
                        marginTop: "8px", display: "flex", alignItems: "bottom",
                        justifyContent: "flex-end"
                      }}
                        title=""
                      >
                        <ByzMuiTextField
                          multiline={true}
                          rows={2}
                          sx={{
                            pt: 1,
                          }}
                        />
                      </ByzTitleAndInputBox>
                    </ByzTitleAndInputBox>
                  </Grid>

                  <Grid md={3} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px"
                      title={t("newborn-patient-assessment.father-working")}
                    >
                      <ByzMuiRadioButton
                        typographyText="yes,no,unknown"
                        layout="row"
                        border="none"
                        fontSize={16}
                      />

                      <ByzTitleAndInputBox marginLeft="0px" sx={{
                        marginTop: "8px", display: "flex", alignItems: "bottom",
                        justifyContent: "flex-end"
                      }}
                        title=""
                      >
                        <ByzMuiTextField
                          multiline={true}
                          rows={2}
                          sx={{
                            pt: 1,
                          }}
                        />
                      </ByzTitleAndInputBox>
                    </ByzTitleAndInputBox>
                  </Grid>

                  <Grid md={2} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px" justifyContent="none"
                      title={t("newborn-patient-assessment.need-edu-for-discharge")}
                    >
                      <ByzMuiTextField
                        multiline={true}
                        rows={2}
                        sx={{
                          pt: 1,
                        }}
                      />
                    </ByzTitleAndInputBox>
                  </Grid>

                  <Grid md={2} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px" justifyContent="none"
                      title={t("newborn-patient-assessment.mother-baby-experience")}
                    >
                      <ByzMuiTextField
                        multiline={true}
                        rows={2}
                        sx={{
                          pt: 1,
                        }}
                      />
                    </ByzTitleAndInputBox>
                  </Grid>
                </Grid>

                <Divider
                  sx={{
                    borderColor: "black",
                    borderBottomWidth: "2px",
                    my: 2,
                  }}
                />

                <Grid container spacing={2} >

 
                <Grid md={2} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px" justifyContent="none"
                      title={t("newborn-patient-assessment.primary-caregiver")}
                    >
                      <ByzMuiTextField
                        multiline={true}
                        rows={2}
                        sx={{
                          pt: 1,
                        }}
                      />
                    </ByzTitleAndInputBox>
                  </Grid>

                  <Grid md={2} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px"
                      title={t("newborn-patient-assessment.circumcision-request-before-leaving")}
                    >
                      <ByzMuiRadioButton
                        typographyText="yes,no,unknown"
                        layout="row"
                        border="none"
                        fontSize={16}
                      />

                      <ByzTitleAndInputBox marginLeft="0px" sx={{
                        marginTop: "8px", display: "flex", alignItems: "bottom",
                        justifyContent: "flex-end"
                      }}
                        title=""
                      >
                        <ByzMuiTextField
                          multiline={true}
                          rows={2}
                          sx={{
                            pt: 1,
                          }}
                        />
                      </ByzTitleAndInputBox>
                    </ByzTitleAndInputBox>
                  </Grid>


                  <Grid md={2} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px" justifyContent="none"
                      title={t("newborn-patient-assessment.discharge-weight")}
                    >
                      <ByzMuiTextField
                        sx={{
                          pt: 1,
                        }}
                      />
                    </ByzTitleAndInputBox>
                  </Grid>

                  <Grid md={2} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px" justifyContent="none"
                      title={t("newborn-patient-assessment.total-bilirubin")}
                    >
                      <ByzMuiTextField
                        sx={{
                          pt: 1,
                        }}
                      />
                    </ByzTitleAndInputBox>
                  </Grid>

                  <Grid md={3} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px"
                      title={t("newborn-patient-assessment.relatives-info")}
                    >
                      <ByzMuiRadioButton
                        typographyText="yes,no,unknown"
                        layout="row"
                        border="none"
                        fontSize={16}
                      />

                      <ByzTitleAndInputBox marginLeft="0px" sx={{
                        marginTop: "8px", display: "flex", alignItems: "bottom",
                        justifyContent: "flex-end"
                      }}
                        title=""
                      >
                        <ByzMuiTextField
                          multiline={true}
                          rows={2}
                          sx={{
                            pt: 1,
                          }}
                        />
                      </ByzTitleAndInputBox>
                    </ByzTitleAndInputBox>
                  </Grid>
                </Grid>

                <Divider
                  sx={{
                    borderColor: "black",
                    borderBottomWidth: "2px",
                    my: 2,
                  }}
                />

                <Grid container spacing={2}>
                <Grid md={2} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px"
                      title={t("newborn-patient-assessment.genetic-diseases")}
                    >
                      <ByzMuiRadioButton
                        typographyText="yes,no,unknown"
                        layout="row"
                        border="none"
                        fontSize={16}
                      />

                      <ByzTitleAndInputBox marginLeft="0px" sx={{
                        marginTop: "8px", display: "flex", alignItems: "bottom",
                        justifyContent: "flex-end"
                      }}
                        title=""
                      >
                        <ByzMuiTextField
                          multiline={true}
                          rows={2}
                          sx={{
                            pt: 1,
                          }}
                        />
                      </ByzTitleAndInputBox>
                    </ByzTitleAndInputBox>
                  </Grid>
                  <Grid md={2} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px"
                      title={t("newborn-patient-assessment.hereditary-diseases")}
                    >
                      <ByzMuiRadioButton
                        typographyText="yes,no,unknown"
                        layout="row"
                        border="none"
                        fontSize={16}
                      />

                      <ByzTitleAndInputBox marginLeft="0px" sx={{
                        marginTop: "8px", display: "flex", alignItems: "bottom",
                        justifyContent: "flex-end"
                      }}
                        title=""
                      >
                        <ByzMuiTextField
                          multiline={true}
                          rows={2}
                          sx={{
                            pt: 1,
                          }}
                        />
                      </ByzTitleAndInputBox>
                    </ByzTitleAndInputBox>
                  </Grid>
                  <Grid md={2} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px"
                      title={t("newborn-patient-assessment.known-diseases")}
                    >
                      <ByzMuiRadioButton
                        typographyText="yes,no,unknown"
                        layout="row"
                        border="none"
                        fontSize={16}
                      />

                      <ByzTitleAndInputBox marginLeft="0px" sx={{
                        marginTop: "8px", display: "flex", alignItems: "bottom",
                        justifyContent: "flex-end"
                      }}
                        title=""
                      >
                        <ByzMuiTextField
                          multiline={true}
                          rows={2}
                          sx={{
                            pt: 1,
                          }}
                        />
                      </ByzTitleAndInputBox>
                    </ByzTitleAndInputBox>
                  </Grid>

                  <Grid md={2} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px"
                      title={t("newborn-patient-assessment.hearing-loss-history")}
                    >
                      <ByzMuiRadioButton
                        typographyText="yes,no,unknown"
                        layout="row"
                        border="none"
                        fontSize={16}
                      />

                      <ByzTitleAndInputBox marginLeft="0px" sx={{
                        marginTop: "8px", display: "flex", alignItems: "bottom",
                        justifyContent: "flex-end"
                      }}
                        title=""
                      >
                        <ByzMuiTextField
                          multiline={true}
                          rows={2}
                          sx={{
                            pt: 1,
                          }}
                        />
                      </ByzTitleAndInputBox>
                    </ByzTitleAndInputBox>
                  </Grid>

                  <Grid md={2} xs={6}>
    <ByzTitleAndInputBox marginLeft="0px"
      title={t("newborn-patient-assessment.desc-hear-loss")}
    >
      <ByzMuiRadioButton
        typographyText="yes,no,unknown"
        layout="row"
        border="none"
        fontSize={16}
      />

      <ByzTitleAndInputBox marginLeft="0px" sx={{
        marginTop: "8px", display: "flex", alignItems: "bottom",
        justifyContent: "flex-end"
      }}
        title=""
      >
        <ByzMuiTextField
          multiline={true}
          rows={2}
          sx={{
            pt: 1,
          }}
        />
      </ByzTitleAndInputBox>
    </ByzTitleAndInputBox>
  </Grid>


                </Grid>

                <Divider
                  sx={{
                    borderColor: "black",
                    borderBottomWidth: "2px",
                    my: 2,
                  }}
                />

                <Grid container spacing={2}>
                <Grid md={3} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px"
                      title={t("newborn-patient-assessment.siblings-jaundice")}
                    >
                      <ByzMuiRadioButton
                        typographyText="yes,no,unknown"
                        layout="row"
                        border="none"
                        fontSize={16}
                      />

                      <ByzTitleAndInputBox marginLeft="0px" sx={{
                        marginTop: "8px", display: "flex", alignItems: "bottom",
                        justifyContent: "flex-end"
                      }}
                        title=""
                      >
                        <ByzMuiTextField
                          multiline={true}
                          rows={2}
                          sx={{
                            pt: 1,
                          }}
                        />
                      </ByzTitleAndInputBox>
                    </ByzTitleAndInputBox>
                  </Grid>

                  <Grid md={3} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px"
                      title={t("newborn-patient-assessment.sick-sibling-history")}
                    >
                      <ByzMuiRadioButton
                        typographyText="yes,no,unknown"
                        layout="row"
                        border="none"
                        fontSize={16}
                      />

                      <ByzTitleAndInputBox marginLeft="0px" sx={{
                        marginTop: "8px", display: "flex", alignItems: "bottom",
                        justifyContent: "flex-end"
                      }}
                        title=""
                      >
                        <ByzMuiTextField
                          multiline={true}
                          rows={2}
                          sx={{
                            pt: 1,
                          }}
                        />
                      </ByzTitleAndInputBox>
                    </ByzTitleAndInputBox>
                  </Grid>
                  <Grid md={2} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px"
                      title={t("newborn-patient-assessment.checkup-appointment")}
                    >
                      <ByzMuiSelect
                        renderInput={(params) => (
                          <ByzMuiTextField {...params} />
                        )}
                        options={checkupAppointmentOptions}
                        label= "label"
                        placeholder={t("open-process-menu.select")}
                        sx={{ pt: 1 }}
                        multiple = {false}
                      />

                      <ByzTitleAndInputBox marginLeft="0px" sx={{
                        marginTop: "8px", display: "flex", alignItems: "bottom",
                        justifyContent: "flex-end"
                      }}
                        title={t("description")}
                      >
                        <ByzMuiTextField
                          multiline={true}
                          rows={2}
                          sx={{
                            pt: 1,
                          }}
                        />
                      </ByzTitleAndInputBox>
                    </ByzTitleAndInputBox>
                  </Grid>

                  <Grid md={2} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px"
                        title={t("newborn-patient-assessment.hip-usg-appointment")}
                        >
                          <ByzMuiSelect
                            renderInput={(params) => (
                              <ByzMuiTextField {...params} />
                            )}
                            options={hipUsgAppointmentOptions}
                            label= "label"
                            placeholder={t("open-process-menu.select")}
                            sx={{ pt: 1 }}
                            multiple = {false}
                          />

                          <ByzTitleAndInputBox marginLeft="0px" sx={{
                            marginTop: "8px", display: "flex", alignItems: "bottom",
                            justifyContent: "flex-end"
                          }}
                            title={t("description")}
                          >
                            <ByzMuiTextField
                              multiline={true}
                              rows={2}
                              sx={{
                                pt: 1,
                              }}
                            />
                          </ByzTitleAndInputBox>
                        </ByzTitleAndInputBox>
                  </Grid>
                  <Grid md={2} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px"
                      title={t("newborn-patient-assessment.child-seat-info")}
                    >
                      <ByzMuiRadioButton
                        typographyText="yes,no,unknown"
                        layout="row"
                        border="none"
                        fontSize={16}
                      />

                      <ByzTitleAndInputBox marginLeft="0px" sx={{
                        marginTop: "8px", display: "flex", alignItems: "bottom",
                        justifyContent: "flex-end"
                      }}
                        title=""
                      >
                        <ByzMuiTextField
                          multiline={true}
                          rows={2}
                          sx={{
                            pt: 1,
                          }}
                        />
                      </ByzTitleAndInputBox>
                    </ByzTitleAndInputBox>
                  </Grid>




</Grid>

<Divider
sx={{
borderColor: "black",
borderBottomWidth: "2px",
my: 2,
}}
/>

<Grid container spacing={2}>
<Grid md={2} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px"
                      title={t("newborn-patient-assessment.unsafe-medications-info")}
                    >
                      <ByzMuiRadioButton
                        typographyText="yes,no,unknown"
                        layout="row"
                        border="none"
                        fontSize={16}
                      />

                      <ByzTitleAndInputBox marginLeft="0px" sx={{
                        marginTop: "8px", display: "flex", alignItems: "bottom",
                        justifyContent: "flex-end"
                      }}
                        title=""
                      >
                        <ByzMuiTextField
                          multiline={true}
                          rows={2}
                          sx={{
                            pt: 1,
                          }}
                        />
                      </ByzTitleAndInputBox>
                    </ByzTitleAndInputBox>
                  </Grid>

                  <Grid md={2} xs={6}>
                    <ByzTitleAndInputBox marginLeft="0px"
                      title={t("newborn-patient-assessment.home-cleaning-supplies")}
                    >
                      <ByzMuiRadioButton
                        typographyText="yes,no,unknown"
                        layout="row"
                        border="none"
                        fontSize={16}
                      />

                      <ByzTitleAndInputBox marginLeft="0px" sx={{
                        marginTop: "8px", display: "flex", alignItems: "bottom",
                        justifyContent: "flex-end"
                      }}
                        title=""
                      >
                        <ByzMuiTextField
                          multiline={true}
                          rows={2}
                          sx={{
                            pt: 1,
                          }}
                        />
                      </ByzTitleAndInputBox>
                    </ByzTitleAndInputBox>
                  </Grid>
<Grid md={2} xs={6}>
<ByzTitleAndInputBox marginLeft="0px"
  title={t("newborn-patient-assessment.barrier-usage-in-flammable-areas")}
>
  <ByzMuiRadioButton
    typographyText="yes,no,unknown"
    layout="row"
    border="none"
    fontSize={16}
  />

  <ByzTitleAndInputBox marginLeft="0px" sx={{
    marginTop: "8px", display: "flex", alignItems: "bottom",
    justifyContent: "flex-end"
  }}
    title=""
  >
    <ByzMuiTextField
      multiline={true}
      rows={2}
      sx={{
        pt: 1,
      }}
    />
  </ByzTitleAndInputBox>
</ByzTitleAndInputBox>
</Grid>
<Grid md={2} xs={6}>
<ByzTitleAndInputBox marginLeft="0px"
  title={t("newborn-patient-assessment.dangerous-objects-access")}
>
  <ByzMuiRadioButton
    typographyText="yes,no,unknown"
    layout="row"
    border="none"
    fontSize={16}
  />

  <ByzTitleAndInputBox marginLeft="0px" sx={{
    marginTop: "8px", display: "flex", alignItems: "bottom",
    justifyContent: "flex-end"
  }}
    title=""
  >
    <ByzMuiTextField
      multiline={true}
      rows={2}
      sx={{
        pt: 1,
      }}
    />
  </ByzTitleAndInputBox>
</ByzTitleAndInputBox>
</Grid>

<Grid md={2} xs={6}>
<ByzTitleAndInputBox marginLeft="0px"
  title={t("newborn-patient-assessment.baby-bed-info")}
>
  <ByzMuiRadioButton
    typographyText="yes,no,unknown"
    layout="row"
    border="none"
    fontSize={16}
  />

  <ByzTitleAndInputBox marginLeft="0px" sx={{
    marginTop: "8px", display: "flex", alignItems: "bottom",
    justifyContent: "flex-end"
  }}
    title=""
  >
    <ByzMuiTextField
      multiline={true}
      rows={2}
      sx={{
        pt: 1,
      }}
    />
  </ByzTitleAndInputBox>
</ByzTitleAndInputBox>
</Grid>
</Grid>

<Divider
sx={{
borderColor: "black",
borderBottomWidth: "2px",
my: 2,
}}
/>

<Grid container spacing={2}>
<Grid md={3} xs={6}>
<ByzTitleAndInputBox marginLeft="0px"
  title={t("newborn-patient-assessment.smoker-in-house")}
>
  <ByzMuiRadioButton
    typographyText="yes,no,unknown"
    layout="row"
    border="none"
    fontSize={16}
  />

  <ByzTitleAndInputBox marginLeft="0px" sx={{
    marginTop: "8px", display: "flex", alignItems: "bottom",
    justifyContent: "flex-end"
  }}
    title=""
  >
    <ByzMuiTextField
      multiline={true}
      rows={2}
      sx={{
        pt: 1,
      }}
    />
  </ByzTitleAndInputBox>
</ByzTitleAndInputBox>
</Grid>

<Grid md={2} xs={6}>
<ByzTitleAndInputBox marginLeft="0px"
  title={t("newborn-patient-assessment.mother-needs-meeting")}
>
  <ByzMuiRadioButton
    typographyText="yes,no,unknown"
    layout="row"
    border="none"
    fontSize={16}
  />

  <ByzTitleAndInputBox marginLeft="0px" sx={{
    marginTop: "8px", display: "flex", alignItems: "bottom",
    justifyContent: "flex-end"
  }}
    title=""
  >
    <ByzMuiTextField
      multiline={true}
      rows={2}
      sx={{
        pt: 1,
      }}
    />
  </ByzTitleAndInputBox>
</ByzTitleAndInputBox>
</Grid>
<Grid md={2} xs={6}>
<ByzTitleAndInputBox marginLeft="0px" justifyContent="none"
  title={t("newborn-patient-assessment.baby-hygiene-change")}
>
  <ByzMuiTextField
    multiline={true}
    rows={2}
    sx={{
      pt: 1,
    }}
  />
</ByzTitleAndInputBox>
</Grid>

<Grid md={2} xs={6}>
<ByzTitleAndInputBox marginLeft="0px" justifyContent="none"
  title={t("newborn-patient-assessment.baby-bath-frequency")}
>
  <ByzMuiTextField
    multiline={true}
    rows={2}
    sx={{
      pt: 1,
    }}
  />
</ByzTitleAndInputBox>
</Grid>

<Grid md={2} xs={6}>
<ByzTitleAndInputBox marginLeft="0px" justifyContent="none"
  title={t("newborn-patient-assessment.baby-care-education")}
>
  <ByzMuiRadioButton
    typographyText="exists,not-exists"
    layout="row"
    border="none"
    fontSize={16}
  />
</ByzTitleAndInputBox>
</Grid>






</Grid>

<Divider
sx={{
borderColor: "black",
borderBottomWidth: "2px",
my: 2,
}}
/>

<Grid container spacing={2}>
<Grid md={3} xs={6}>
  <ByzTitleAndInputBox marginLeft="0px" justifyContent="none"
    title={t("newborn-patient-assessment.sleep-issue-info")}
  >
    <ByzMuiRadioButton
      typographyText="exists,not-exists"
      layout="row"
      border="none"
      fontSize={16}
    />
  </ByzTitleAndInputBox>
</Grid>
</Grid>

</Box>
</Grid>
</Grid>
</Grid>
</Box>
</>
);
}

export default PageTwo;